/* eslint-disable prettier/prettier */
/* eslint-disable import/named */
import '../../../styles/IncomingClaimPage.scss';
import 'react-datepicker/dist/react-datepicker.css';
import { AllClaimsPageProps, AllClaimsPageState, IncomingPageState } from '../typings';
import { Badge, Button, Input, Label, Popover, PopoverBody, PopoverHeader, Table } from 'reactstrap/lib';
import { DropdownOption, IProfile } from '../new/typings';
import {
  FirebaseReducer,
  FirestoreReducer,
  ReduxFirestoreQueries,
  firestoreConnect,
  isLoaded,
} from 'react-redux-firebase';
import { RouteComponentProps } from 'react-router';
import { authorizedOptions, orderPaymentTodos, poptions, selectStyles, statusOptions } from '../../../helpers/utils';
import { calendar, check, download, loader, search, user, x } from 'react-icons-kit/feather';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { downloadClaimInfo } from '../../../actions/update-claim';
import CompletedSidePanel from '../side-panel/CompletedSidePanel';
import DatePicker from 'react-datepicker';
import EmptyState from '../empty-state/EmptyState';
import Helmet from 'react-helmet';
import Icon from 'react-icons-kit';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadingPage from '../../loading/LoadingPage';
import React, { Component } from 'react';
import Select, { ValueType } from 'react-select';
import _ from 'lodash';
import moment from 'moment';

let claimsListCurrent = 0;

class AllClaimsPage extends Component<
  RouteComponentProps & FirebaseReducer.Reducer & AllClaimsPageProps,
  AllClaimsPageState
> {
  private static INITIAL_STATE: IncomingPageState = {
    activeClaim: null,
  };

  private static propKey(propertyName: string, value: any): object {
    return { [propertyName]: value };
  }

  private setStateWithEvent(event: any, columnType: string): void {
    this.setState(AllClaimsPage.propKey(columnType, (event.target as any).value));
  }

  constructor(props: any) {
    super(props);
    this.state = {
      ...AllClaimsPage.INITIAL_STATE,
      statusFilter: { value: 'STATUS', label: 'ALL' },
      authorizedFilter: { value: 'Both', label: 'Both' },
      partnerFilter: { value: 'Partner', label: 'Member' },
      countryFilter: { value: 'Country', label: 'Country' },
      searchStringVal: '',
      popoverOpen: false,
      dowloadLoading: {},
      isAdmin: false,
      partnerId: undefined,
      sortCreatedByFilter: 'desc' as 'asc' | 'desc',
      sortUpdatedByFilter: 'desc' as 'asc' | 'desc',
      sortBy: null,
    };
  }

  public selectClaim(id: string | null) {
    this.setState(AllClaimsPage.propKey('activeClaim', id));
  }

  fetchMoreData = () => {
    const next = this.props?.pagination?.take || 0;
    typeof this.props.loadMore === 'function' && this.props.loadMore(next + 10);
  };

  onSearchBtnClick = () => {
    typeof this.props.searchChange === 'function' &&
      this.props.searchChange(this.state.searchStringVal || '');
  };

  onResetSearchBtnClick = () => {
    this.setState({ searchStringVal: '' });
    typeof this.props.searchChange === 'function' && this.props.searchChange('');
  };

  options = statusOptions.map((status: string) => {
    if (status === 'STATUS') {
      return {
        value: status,
        label: 'ALL',
      };
    }
    return {
      value: status,
      label: status,
    };
  });

  poptions = poptions.map((status: string) => {
    if (status === 'Partner') {
      return {
        value: status,
        label: 'Member',
      };
    }
    return {
      value: status,
      label: status,
    };
  });

  authorizedOpts = authorizedOptions.map((status: string) => {
    return {
      value: status,
      label: status,
    };
  });

  openPdf = (base64str: string, id: string) => {
    const binary = atob(base64str.replace(/\s/g, ''));
    const len = binary.length;
    const buffer = new ArrayBuffer(len);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i);
    }
    const blob = new Blob([view], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url);
    const dowloadLoadingCurrent = { ...this.state.dowloadLoading };
    dowloadLoadingCurrent[id] = false;
    this.setState({ dowloadLoading: { ...dowloadLoadingCurrent } });
  };

  downloadProofOfWork = async (claimId: string) => {
    const dowloadLoadingCurrent = { ...this.state.dowloadLoading };
    dowloadLoadingCurrent[claimId] = true;
    try {
      this.setState({ dowloadLoading: { ...dowloadLoadingCurrent } });
      const pdfFile = await downloadClaimInfo(claimId || '', false);
      if (pdfFile) {
        this.openPdf(pdfFile, claimId);
      }
    } catch (e) {
      dowloadLoadingCurrent[claimId] = true;
      this.setState({ dowloadLoading: { ...dowloadLoadingCurrent } });
      console.error(e);
    }
  };

  componentDidUpdate = () => {
    const { claims } = this.props;
    const { activeClaim } = this.state;
    if (activeClaim && !claims[activeClaim]) {
      this.selectClaim(null);
    }
    const { partnerId: partnerIdProfile = '' } = this.props?.profile || {};
    if (this.state.partnerId !== partnerIdProfile) {
      if (this.props?.profile.partnerId === 'Admin') {
        this.setState({ isAdmin: true, partnerId: partnerIdProfile });
      } else if (partnerIdProfile !== 'Admin') {
        this.setState({ isAdmin: false, partnerId: partnerIdProfile });
      }
    }
  };

  setSortCreatedByFilter = ()=>{
    console.log('sortCreatedByFilter', this.state.sortCreatedByFilter);
    this.state.sortCreatedByFilter === 'asc'
      ? this.setState({ sortCreatedByFilter: 'desc', sortBy: 'created' })
      : this.setState({ sortCreatedByFilter: 'asc', sortBy: 'created' });
  };

  setSortUpdatedByFilter = ()=>{
    console.log('sortUpdatedByFilter', this.state.sortUpdatedByFilter);
    this.state.sortUpdatedByFilter === 'asc'
      ? this.setState({ sortUpdatedByFilter: 'desc', sortBy: 'updated' })
      : this.setState({ sortUpdatedByFilter: 'asc', sortBy: 'updated' });
  };

  render() {
    const { claims, loading, partner, todos, partnerOptions, partners, countryOptions, dateRangeValue } = this.props;
    const { activeClaim, searchStringVal, isAdmin } = this.state;
    const claim =
      claims && activeClaim && claims[activeClaim]
        ? { ...claims[activeClaim], id: activeClaim }
        : null;

    if (loading) {
      return <LoadingPage />;
    }

    if (_.isEmpty(claims)) {
      return (
        <EmptyState
          message={
            searchStringVal !== '' || dateRangeValue.search
              ? 'No claims match your search'
              : 'There are currently no claims in the system'
          }
        />
      );
    }

    let claimsList: any = claims;

    if (isAdmin) {
      claimsList = _.pickBy(claims, (c) => {
        if (this.state.authorizedFilter.value === 'Authorized') {
          return c.insurer.authorized === true;
        } else if (this.state.authorizedFilter.value === 'Unauthorized') {
          return c.insurer.authorized === false;
        }
        return c;
      });

      claimsList = _.pickBy(claims, (c) => {
        if (this.state.partnerFilter.value !== 'Partner') {
          return c.assign.partner === this.state.partnerFilter.value;
        }
        return c;
      });

      claimsList = _.pickBy(claims, (c) => {
        if (this.state.countryFilter.value !== 'Country') {
          return partners[c.assign.partner || '']?.country === this.state.countryFilter.value;
        }
        return c;
      });

      claimsList = _.pickBy(claims, (c) => {
        if (this.state.statusFilter.value !== 'STATUS') {
          return c.status === this.state.statusFilter.value;
        }
        return c;
      });

      let sortedClaimsList;
      
      if (this.state.sortBy === 'created') { // Assuming you'll add 'sortBy' to your state
          sortedClaimsList = this.state.sortCreatedByFilter === 'asc'
              ? _.sortBy(Object.values(claimsList), (c) => c._audit.created.timestamp)
              : _.sortBy(Object.values(claimsList), (c) => c._audit.created.timestamp).reverse();
          claimsList = _.keyBy(sortedClaimsList, '_audit.created.timestamp');
      } else if (this.state.sortBy === 'updated') {
          sortedClaimsList = this.state.sortUpdatedByFilter === 'asc'
              ? _.sortBy(Object.values(claimsList), (c) => c._audit.updated.timestamp)
              : _.sortBy(Object.values(claimsList), (c) => c._audit.updated.timestamp).reverse();
          claimsList = _.keyBy(sortedClaimsList, '_audit.updated.timestamp');
      } else {
          sortedClaimsList = Object.values(claimsList); // Default to an array of the filtered claims
      }
      
    }

    return (
      <div id="claim-page-scroll" className={`incoming-claim-page-container ${activeClaim ? 'open' : 'closed'}`}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>AGE | Global Lifetime Guarantee Code Verification</title>
        </Helmet>
        <div className="page-header">
          <div className="page-title-div">
            <Label>Global Lifetime Guarantee Code Verification</Label>
          </div>
          <div className="top-controls">
            {isAdmin ? (
              <>
                <Button id="Popover1" className="new-claim-top-btn">
                  <Icon icon={calendar} size={24} />
                  <span>Date Range</span>
                </Button>
                <Popover
                  placement="bottom"
                  isOpen={this.state.popoverOpen}
                  target="Popover1"
                  toggle={() => this.setState({ popoverOpen: !this.state.popoverOpen })}>
                  <PopoverHeader>Select Date Range</PopoverHeader>
                  <PopoverBody>
                    <div className="date-form">
                      <div>
                        <label>From: </label>
                        <DatePicker
                          selected={new Date(dateRangeValue.fromDate)}
                          className="date-input"
                          onChange={(value: Date) => {
                            this.props.setFromDateValue(value.toString());
                          }}
                        />
                      </div>
                      <div>
                        <label>To: </label>
                        <DatePicker
                          selected={new Date(dateRangeValue.toDate)}
                          className="date-input"
                          onChange={(value: Date) => {
                            this.props.setToDateValue(value.toString());
                          }}
                        />
                      </div>
                      <div>
                        <Button
                          outline
                          color="secondary"
                          onClick={() => {
                            this.props.searchDateRange(true);
                            this.setState({
                              popoverOpen: !this.state.popoverOpen,
                            });
                          }}
                          className="search-btn">
                          Done
                        </Button>
                        <Button
                          outline
                          color="secondary"
                          onClick={() => {
                            this.props.setFromDateValue(moment('2000-01-01').toDate().toString());
                            this.props.setToDateValue(moment('2100-01-01').toDate().toString());
                            this.props.searchDateRange(false);
                          }}
                          className="search-btn">
                          Reset
                        </Button>
                      </div>
                    </div>
                  </PopoverBody>
                </Popover>{' '}
              </>
            ) : null}
            <div className="search-control">
              <button
                type="button"
                className="search-icon-btn"
                onClick={this.onSearchBtnClick}
                aria-label="Search claims">
                <Icon icon={search} size={22} />
              </button>
              <Input
                name="search"
                value={this.state.searchStringVal}
                placeholder=" "
                className="search-input"
                onChange={(event) => this.setState({ searchStringVal: event.target.value })}
                onKeyDown={(e: React.KeyboardEvent) => { if (e.key === 'Enter') this.onSearchBtnClick(); }}
              />
            </div>
          </div>
        </div>
        <InfiniteScroll
          dataLength={Object.values(claimsList).length}
          next={this.fetchMoreData}
          hasMore={
            Object.values(claimsList).length >= (this.props?.pagination?.take || 0 - 10) ||
            Object.values(claimsList).length < claimsListCurrent
              ? true
              : false
          }
          scrollableTarget="claim-page-scroll"
          style={{ overflow: 'visible' }}>
          <Table>
            <thead>
              <tr>
                <th>Claim No.</th>
                <th>Make</th>
                <th>Model</th>
                <th>Registration</th>
                {isAdmin ? (
                  <>
                    <th className="text-center">
                      <Select
                        styles={selectStyles}
                        options={this.authorizedOpts}
                        value={this.state.authorizedFilter}
                        onChange={(selectedOption: ValueType<DropdownOption>) => {
                          this.setState({ authorizedFilter: selectedOption });
                        }}
                      />
                    </th>
                    <th className="text-center">
                      <Select
                        styles={selectStyles}
                        options={this.poptions}
                        value={this.state.partnerFilter}
                        onChange={(selectedOption: ValueType<DropdownOption>) => {
                          this.setState({ partnerFilter: selectedOption });
                        }}
                      />
                    </th>
                    <th className="text-center">
                      <Select
                        styles={selectStyles}
                        options={countryOptions}
                        value={this.state.countryFilter}
                        onChange={(selectedOption: ValueType<DropdownOption>) => {
                          this.setState({ countryFilter: selectedOption });
                        }}
                      />
                    </th>
                    <th className="text-center">
                      <Select
                        styles={selectStyles}
                        options={this.options}
                        value={this.state.statusFilter}
                        onChange={(selectedOption: ValueType<DropdownOption>) => {
                          this.setState({ statusFilter: selectedOption });
                        }}
                      />
                    </th>
                    <th className="text-center">Days Open</th>
                    <th
                      className="text-center"
                      onClick={this.setSortCreatedByFilter}
                      style={{ cursor: 'pointer' }}>
                      Created {this.state.sortCreatedByFilter === 'asc' ? '▲' : '▼'}
                    </th>
                    <th
                      className="text-center"
                      onClick={this.setSortUpdatedByFilter}
                      style={{ cursor: 'pointer' }}>
                      Updated {this.state.sortUpdatedByFilter === 'asc' ? '▲' : '▼'}
                    </th>
                  </>
                ) : null}
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {_.map(claimsList, (claim, id: string) => {
                if (claim) {
                  const authorizedIcon = claim && claim?.insurer.authorized ? check : x;
                  const authorizedClass =
                    claim && claim.insurer.authorized ? 'text-success' : 'text-danger';
                  const updateDate = !_.isDate(claim?._audit?.updated?.timestamp)
                    ? moment(claim?._audit?.updated?.timestamp.toDate()).format('DD MMM, YYYY')
                    : '-';
                  const createDateMoment = !_.isDate(claim?._audit?.created?.timestamp)
                    ? moment(claim?._audit?.created?.timestamp.toDate())
                    : moment();
                  const createDate = createDateMoment.format('DD MMM, YYYY');
                  const todayMoment = moment();
                  const daysOpen = Math.max(todayMoment.diff(createDateMoment, 'days'), 1);
                  const normalizedStatus = (claim?.status || '').toUpperCase();
                  const statusClass =
                    normalizedStatus === 'CANCELLED'
                      ? 'status-pill status-pill-cancelled'
                      : normalizedStatus === 'PENDING' || normalizedStatus === 'BOOKED'
                      ? 'status-pill status-pill-pending'
                      : 'status-pill status-pill-completed';
                  return (
                    <tr key={id}>
                      <td>
                        <Button
                          className="table-inline-button"
                          onClick={() => {
                            isAdmin && this.selectClaim(id);
                          }}>
                          {claim?.insurer?.claimNumber}
                        </Button>
                      </td>
                      <td>{claim?.vehicle?.make}</td>
                      <td>{claim?.vehicle?.model}</td>
                      <td>{claim?.vehicle?.registrationNumber}</td>
                      {isAdmin ? (
                        <>
                          <td className="text-center">
                            <Icon icon={authorizedIcon} className={authorizedClass} />
                          </td>
                          <td className="text-center">{claim?.assign?.partner}</td>
                          <td className="text-center">
                            {partners[claim?.assign?.partner || '']?.country
                              ? partners[claim?.assign?.partner || ''].country
                              : ''}
                          </td>
                          <td className="text-center">
                            <span className={statusClass}>{claim?.status}</span>
                          </td>
                          <td className="text-center">
                            <Badge color="secondary" size="lg">
                              {daysOpen}
                            </Badge>
                          </td>
                          <td className="text-center">{createDate}</td>
                          <td className="text-center">{updateDate}</td>
                        </>
                      ) : null}
                      <td className="text-center">
                        {!claim?.active && claim?.status === 'COMPLETED' ? (
                          <>
                            {!this.state.dowloadLoading[id] ? (
                              <div title="Download Lifetime Guarantee Certificate">
                                <Icon
                                  onClick={this.downloadProofOfWork.bind(this, id)}
                                  icon={download}
                                  size={16}
                                />
                              </div>
                            ) : (
                              <div>
                                <Icon icon={loader} className="spin" size={16} />
                              </div>
                            )}
                          </>
                        ) : (
                          false
                        )}
                      </td>
                      <td className="text-center">
                        {claim?.assign?.owners?.partner ? (
                          <div className="claim-user-icon">
                            <Icon icon={user} size={10} />
                          </div>
                        ) : (
                          false
                        )}
                      </td>
                    </tr>
                  );
                } else return null;
              })}
            </tbody>
          </Table>
        </InfiniteScroll>
        <CompletedSidePanel
          claim={claim}
          todos={todos}
          partner={partner}
          onClose={() => this.selectClaim(null)}
        />
      </div>
    );
  }
}

const preMapStateToProps = (state: any) => {
  const {
    firebase: { profile },
    pagination,
    searchString,
    dateRangeValue,
  }: {
    firebase: FirebaseReducer.Reducer;
    pagination: { skip: number; take: number };
    searchString: { searchString: string };
    dateRangeValue: { toDate: string; fromDate: string; search: boolean };
  } = state;
  return {
    profile: profile,
    pagination,
    searchString,
    dateRangeValue,
  };
};

const mapQueryToProps = ({
  profile,
  pagination,
  searchString,
  dateRangeValue,
  firestore,
}: {
  profile: IProfile;
  pagination: { skip: number; take: number };
  searchString: { searchString: string };
  dateRangeValue: { toDate: string; fromDate: string; search: boolean };
  firestore: FirestoreReducer.Reducer;
}): ReduxFirestoreQueries => {
  if (!profile.isLoaded || profile.isEmpty) {
    return [];
  }
  let fromDate = moment('2000-01-01').toDate();
  let toDate = moment('2100-01-01').toDate();
  if (dateRangeValue.search) {
    fromDate =  new Date(dateRangeValue.fromDate);
    toDate = new Date(dateRangeValue.toDate);
  }
  fromDate = firestore.Timestamp.fromDate(fromDate);
  toDate = firestore.Timestamp.fromDate(toDate);
  const isAdmin = profile.partnerId === 'Admin';
  const ongoingStatuses = [
    'NEW', 'CONTACTED', 'BOOKED', 'EXCESS_COLLECTED',
    'SERVICE DONE', 'ACCEPTED', 'INVOICED', 'CANCELLED',
  ];
  if (searchString.searchString === '') {
    const baseWhere: any[] = isAdmin
      ? [
          ['_audit.created.timestamp', '>=', fromDate],
          ['_audit.created.timestamp', '<=', toDate],
        ]
      : [
          ['assign.partner', '==', profile.partnerId],
          ['status', 'in', ongoingStatuses],
          ['_audit.created.timestamp', '>=', fromDate],
          ['_audit.created.timestamp', '<=', toDate],
        ];
    return [
      {
        collection: 'claims',
        where: baseWhere,
        limit: pagination.take,
        orderBy: ['_audit.created.timestamp', 'desc'],
        storeAs: 'allClaims',
      },
      {
        collection: 'config',
        doc: 'todos',
        storeAs: 'todosConfig',
      },
      {
        collection: 'partners',
        storeAs: 'partners',
      },
    ];
  } else {
    const claimNumberWhere: any[] = isAdmin
      ? [['insurer.claimNumber', '==', searchString.searchString]]
      : [['assign.partner', '==', profile.partnerId], ['insurer.claimNumber', '==', searchString.searchString], ['status', 'in', ongoingStatuses]];
    const regWhere: any[] = isAdmin
      ? [['vehicle.registrationNumber', '==', searchString.searchString]]
      : [['assign.partner', '==', profile.partnerId], ['vehicle.registrationNumber', '==', searchString.searchString], ['status', 'in', ongoingStatuses]];
    return [
      {
        collection: 'claims',
        where: claimNumberWhere,
        storeAs: 'allClaims',
      },
      {
        collection: 'claims',
        where: regWhere,
        storeAs: 'claimsReg',
      },
      {
        collection: 'config',
        doc: 'todos',
        storeAs: 'todosConfig',
      },
      {
        collection: 'partners',
        storeAs: 'partners',
      },
    ];
  }
};

const mapDispatchToProps = (dispatch: any) => ({
  loadMore: (skip: number) => {
    dispatch({
      type: 'LOAD_MORE',
      value: skip,
    });
  },
  searchChange: (searchVal: string) => {
    dispatch({
      type: 'SEARCH_CHANGE',
      value: searchVal,
    });
  },
  setToDateValue: (toDateValue: string) => {
    dispatch({
      type: 'SET_TO_DATE_VALUE',
      value: toDateValue,
    });
  },
  setFromDateValue: (fromDateValue: string) => {
    dispatch({
      type: 'SET_FROM_DATE_VALUE',
      value: fromDateValue,
    });
  },
  searchDateRange: (value: boolean) => {
    dispatch({
      type: 'SEARCH_DATE_RANGE',
      value: value,
    });
  },
});

const mapStateToProps = (state: any) => {
  const {
    firestore,
    firebase: { auth },
    pagination,
    searchString,
    dateRangeValue,
  }: {
    firestore: FirestoreReducer.Reducer;
    firebase: FirebaseReducer.Reducer;
    pagination: { skip: number; take: number };
    searchString: { searchString: string };
    dateRangeValue: { toDate: string; fromDate: string; search: boolean };
  } = state;
  let partner = '';
  const partners = firestore.data.partners;
  let claims = firestore.data.allClaims;
  if (searchString.searchString !== '') {
    if (firestore.data.allClaims) {
      claims = firestore.data.allClaims;
    } else if (firestore.data.claimsReg) {
      claims = firestore.data.claimsReg;
    }
  }
  const todosConfig = firestore.data.todosConfig;
  const loading = !isLoaded(claims) || !isLoaded(todosConfig) || !isLoaded(partners);
  let todos = null;
  const partnerOptions: Array<{ value: string; label: string }> = [];
  const countryOptions: Array<{ value: string; label: string }> = [];
  if (!loading) {
    const masterTodo = todosConfig.todos;
    partner = partners['AutoglassClinic'];
    const partnerConfig = partners['AutoglassClinic']?.todoTemplate?.todos;
    todos = orderPaymentTodos(_.assign({}, masterTodo, partnerConfig));
    if (claims && claimsListCurrent < Object.values(claims).length) {
      claimsListCurrent = Object.values(claims).length;
    }
    _.map(partners, (partner, id) => {
      partnerOptions.push({ value: id, label: partner.name });
      countryOptions.push({ value: partner.country, label: partner.country });
    });
    partnerOptions.push({ value: 'Partner', label: 'Member' });
    countryOptions.push({ value: 'Country', label: 'Country' });
  }
  return {
    loading,
    claims,
    todos,
    partner,
    partners,
    pagination,
    partnerOptions,
    countryOptions,
    dateRangeValue,
    auth: auth as FirebaseReducer.AuthState,
  };
};

export default compose(
  connect(preMapStateToProps),
  firestoreConnect(mapQueryToProps),
  connect(mapStateToProps, mapDispatchToProps),
)(AllClaimsPage);
